import React from 'react'

export default function container({children}) {
  return (
    <main className='container'>{children}</main>
  )
}
